module.exports = __webpack_public_path__ + "static/media/notco_los_angeles_22.b69f5ca1.png";